<template>
  <v-container class="pa-0" fluid>
    <v-row align="center" justify="center" v-if="showEmptyWishListSection" style="height: 300px;">
      <v-col cols="12" md="12" class="text-center">
        <div class="body-heading-medium mb-2">No item in the wish list yet!</div>
        <div class="mb-2" v-if="isKid">
          Add more items to your wish list!
        </div>
      </v-col>
    </v-row>

    <v-row v-else class="fill-height">
      <v-col v-for="wish of wishes" :key="wish.product_id" cols="12" md="4">
        <ProductPreview :key="wish.product_id" :id="wish.product_id" :name="wish.product.name" :image="wish.product.image" :points="wish.product.points" />
      </v-col>
    </v-row>
    <!-- TODO: add pagination here -->
  </v-container>
</template>

<script>
  import ProductPreview from "@/components/Products/Preview";

  export default {
    name: "KidGiftWishlist",

    computed: {
      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      userId() {
        return this.$route.params.id ? this.$route.params.id : this.$store.getters.userInfo.id;
      },

      wishes() {
        return this.$store.getters.filterWishesByKidId(this.userId);
      },

      showEmptyWishListSection() {
        if (this.wishes.length > 0) {
          return false;
        }
        return true;
      },
    },

    components: { ProductPreview },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidGiftWishlist.vue